import {railStates} from './../../ukrail/ukrail-routes';
export const TICKET_CLASS_FIRST = 'F';
import canBeAmendedStatuses from '../../trip/can-be-amended-statuses';

export default function TripChangeTicketService(
    $state,
    l10nService,
) {
    'ngInject';

    Object.assign(this, {
        navigateToSearchForm,
        isFirstClass,
        getFirstStop,
        getLastStop,
        getTooltipTextById,
        isItemCanBeAmended,
        l10nService,
    });

    function navigateToSearchForm({railGroup, areTicketsCollected, railRecommendation, tripId, groupTicketsPrice: oldPrice, travellersCount}) {
        const TRIP_TYPE_ONEWAY = 'Oneway';

        const first = getFirstStop(railGroup);
        const last = getLastStop(railGroup);
        const departureDate = getDepartureDate(railGroup);

        const rebook = {
            tripId,
            oldPrice,
            travellersCount,
            areTicketsCollected,
            isRoundtrip: railRecommendation.ReturnOrSingle === TRIP_TYPE_ONEWAY,
            rejectedGroupId: railGroup.Id,
            arrival: {
                StationCode: last.ArrivalStationCode,
                CityName: last.ArrivalStationCity,
                StationName: last.ArrivalStation,
                DisplayString: last.ArrivalStation,
                IsCity: last.IsCity,
            },
            departure: {
                date: departureDate,
                StationCode: first.DepartureStationCode,
                CityName: first.DepartureStationCity,
                StationName: first.DepartureStation,
                DisplayString: first.DepartureStation,
                IsCity: first.IsCity,
            },
        };
        $state.go(railStates.ONEWAY, {rebook});
    }

    function getDepartureDate(railGroup) {
        return Array.isArray(railGroup.Rails)
            ? railGroup.Rails[0].DepartureDate
            : '';
    }

    function isFirstClass(railGroup) {
        return getFirstStop(railGroup).TicketClass === TICKET_CLASS_FIRST;
    }

    function getFirstStop(railGroup) {
        const [first] = railGroup.Rails;
        return first;
    }

    function getLastStop(railGroup) {
        const length = railGroup.Rails.length;
        return railGroup.Rails[length - 1];
    }

    function isItemCanBeAmended(railRecommendation) {
        return railRecommendation.CanBeAmended === canBeAmendedStatuses.OK;
    }

    function getTooltipTextById(id) {
        switch (id) {
            case canBeAmendedStatuses.DeliveryMethodPrintYourOwn:
                return l10nService.localize('Bookings with this delivery method cannot be changed');
            case canBeAmendedStatuses.TicketsNotConfirmed:
                return l10nService.localize('Amend journey is available only for confirmed tickets');
            case canBeAmendedStatuses.NoItemsAvailable:
                return l10nService.localize('This journey has no items eligible for amendment');
            case canBeAmendedStatuses.AlreadyAmended:
                return l10nService.localize('The ticket has already been amended');
            case canBeAmendedStatuses.InAmendmentApprovalProcess:
                return l10nService.localize('Amend journey is not available until Trip is confirmed.');
            case canBeAmendedStatuses.InternetOnlyBooking:
                return l10nService.localize('Tickets with "Online" type can not be amended');
            default:
                return '';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-change-ticket/trip-change-ticket-service.js